/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Les_Start_Api_Errors_Les_Not_In_ConceptInputs */

const nl_les_start_api_errors_les_not_in_concept = /** @type {(inputs: Les_Start_Api_Errors_Les_Not_In_ConceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze les is al gestart of afgesloten. Ververs de pagina om de actuele status te zien.`)
};

/**

* @param {Les_Start_Api_Errors_Les_Not_In_ConceptInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const les_start_api_errors_les_not_in_concept = /** @type {((inputs?: Les_Start_Api_Errors_Les_Not_In_ConceptInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Les_Start_Api_Errors_Les_Not_In_ConceptInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_les_start_api_errors_les_not_in_concept(inputs)
});
export { les_start_api_errors_les_not_in_concept as "les.start.api_errors.les_not_in_concept" }